import { BANDS, CELLS, CONSOLE_TABS, GAME_STATUSES, MW_CATEGORIES, MW_DISPOSITIONS, MW_IR_INTENSITIES, MW_OBSERVABLE_FIELDS, MW_STAGES, OUTCOMES, RUNGS, SEAT_IDS, STATUSES, TEAM_IDS, TIMING_PROFILES, TURN_PHASES, } from '@badger-sentinel/rules';
import { z } from 'zod';
export const zTeamId = z.enum(TEAM_IDS);
export const zCell = z.enum(CELLS);
export const zSeatId = z.enum(SEAT_IDS);
export const zBand = z.enum(BANDS);
export const zRung = z.enum(RUNGS);
export const zStatus = z.enum(STATUSES);
export const zOutcome = z.enum(OUTCOMES);
export const zGameStatus = z.enum(GAME_STATUSES);
export const zTurnPhase = z.enum(TURN_PHASES);
export const zTimingProfile = z.enum(TIMING_PROFILES);
/** The console's five modules (M5 Q15). A seat sees the subset its scenario gives it. */
export const zConsoleTab = z.enum(CONSOLE_TABS);
// Missile Warning (RB §5.3) — M4.
export const zMwCategory = z.enum(MW_CATEGORIES);
export const zMwDisposition = z.enum(MW_DISPOSITIONS);
export const zMwIrIntensity = z.enum(MW_IR_INTENSITIES);
export const zMwStage = z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]);
/** `0` is "no data yet" — a track exists but stage 1 has not fired (decision M4-D6). */
export const zMwRevealCursor = z.union([z.literal(0), zMwStage]);
/**
 * The observable field names, flattened from the per-stage table. Built from the
 * rules tuple rather than restated, so a field added to a stage cannot fail to reach
 * the wire vocabulary.
 */
export const MW_OBSERVABLE_FIELD_NAMES = [
    ...MW_OBSERVABLE_FIELDS[1],
    ...MW_OBSERVABLE_FIELDS[2],
    ...MW_OBSERVABLE_FIELDS[3],
    ...MW_OBSERVABLE_FIELDS[4],
];
export const zMwObservableField = z.enum(MW_OBSERVABLE_FIELD_NAMES);
/** MW stage timings are `ordersMs / 6` apart (RB §5.3.4, decision M4-D9). */
export const MW_STAGE_COUNT = MW_STAGES.length;
export const MW_STAGE_DIVISOR = 6;
/** `BSNT-4K9P` (§3.1). Case-insensitive on input, upper-cased on parse. */
export const zGameCode = z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^BSNT-[A-Z0-9]{4}$/, 'Game code must look like BSNT-4K9P');
//# sourceMappingURL=enums.js.map